import { useMemo } from 'react';
import { withStyles, Icon, SelectRenderOptionArgs } from 'vopay';
import styles from './SelectOptionLocked.module.scss';
import { useAccountingSoftware } from '../AccountingSoftwareContext';

const classes = withStyles(styles);

type ComponentProps = SelectRenderOptionArgs & {
  onClick?: () => void;
  children: React.ReactNode;
  featureKey: string;
  disabled?: boolean;
};

// Feature-local copy of the portal's SelectOptionLocked: locked state comes
// from the account facts on the feature context, and a locked click is handed
// to the host (which may show its upsell dialog) instead of a portal provider.
function SelectOptionLocked({
  Option,
  SelectedIcon,
  children,
  onClick,
  preventDefault,
  selected,
  featureKey,
  disabled,
}: ComponentProps) {
  const { account, hostActions } = useAccountingSoftware();
  const { LockedSelectOptions } = account;
  const locked = useMemo(() => LockedSelectOptions && featureKey in LockedSelectOptions, [LockedSelectOptions]);

  return (
    <Option
      onClick={() => {
        if (locked) {
          preventDefault();
          hostActions.onLockedFeature?.(featureKey);
          onClick && onClick();
        } else if (disabled) {
          preventDefault();
          onClick && onClick();
        }
      }}
      className={classes((locked || disabled) && 'locked')}
    >
      <div className={classes('left')}>
        {locked && <Icon width="min-content" height="min-content" icon="lock2" size="sm" bgColor="primary-light" />}

        {children}
      </div>

      {selected && <SelectedIcon />}
    </Option>
  );
}

export default SelectOptionLocked;
